DR.events = DR.events || {};
DR.events.struct = DR.events.struct || {};
DR.events.select = DR.events.select || {};
/** @extends {DR._Base} */
DR.events.struct.Sponsor = function(par){
	/** @private */
	this._t = 1289;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.description)) this.description = String(par.description||'');
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.name)) this.name = String(par.name||'');
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1289] = DR.events.struct.Sponsor;
DR.events.struct.Sponsor[__P] = new DR._Base;
DR.events.struct.Sponsor[__P][__C] = DR.events.struct.Sponsor;
/** @type {String} */
DR.events.struct.Sponsor.prototype.description = null;
/** @type {DR.roadgames.struct.Image} */
DR.events.struct.Sponsor.prototype.image = null;
/** @type {String} */
DR.events.struct.Sponsor.prototype.name = null;
/** @type {String} */
DR.events.struct.Sponsor.prototype.url = null;

/** @extends {DR._Base} */
DR.events.struct.DiscountData = function(par){
	/** @private */
	this._t = 1287;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.amount)) this.amount = (parseInt(par.amount)||0);
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
};
DR._Base._types[1287] = DR.events.struct.DiscountData;
DR.events.struct.DiscountData.TYPE_STATIC = "static";
DR.events.struct.DiscountData.TYPE_PERCENT = "percent";
DR.events.struct.DiscountData[__P] = new DR._Base;
DR.events.struct.DiscountData[__P][__C] = DR.events.struct.DiscountData;
/** @type {Number} */
DR.events.struct.DiscountData.prototype.amount = null;
/** @type {String} */
DR.events.struct.DiscountData.prototype.type = null;

/** @extends {DR._Base} */
DR.events.struct.TicketPrice = function(par){
	/** @private */
	this._t = 1170;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.isActive)) this.isActive = Boolean(par.isActive);
	if(DR._Base.is(par.price)) this.price = (parseInt(par.price)||0);
	if(DR._Base.is(par.priceChange)) this.priceChange = (parseInt(par.priceChange)||0);
	if(DR._Base.is(par.priceType)) this.priceType = String(par.priceType||'');
};
DR._Base._types[1170] = DR.events.struct.TicketPrice;
DR.events.struct.TicketPrice[__P] = new DR._Base;
DR.events.struct.TicketPrice[__P][__C] = DR.events.struct.TicketPrice;
/** @type {Boolean} */
DR.events.struct.TicketPrice.prototype.isActive = null;
/** @type {Number} */
DR.events.struct.TicketPrice.prototype.price = null;
/** @type {Number} */
DR.events.struct.TicketPrice.prototype.priceChange = null;
/** @type {String} */
DR.events.struct.TicketPrice.prototype.priceType = null;

/** @extends {DR._Base} */
DR.events.struct.EventLanding = function(par){
	/** @private */
	this._t = 1320;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.pic)) this.pic = DR._Base.cast(par.pic);
	if(DR._Base.is(par.picMobile)) this.picMobile = DR._Base.cast(par.picMobile);
	if(DR._Base.is(par.video)) this.video = DR._Base.cast(par.video);
	if(DR._Base.is(par.videoMobile)) this.videoMobile = DR._Base.cast(par.videoMobile);
};
DR._Base._types[1320] = DR.events.struct.EventLanding;
DR.events.struct.EventLanding[__P] = new DR._Base;
DR.events.struct.EventLanding[__P][__C] = DR.events.struct.EventLanding;
/** @type {DR.roadgames.struct.Image|null} */
DR.events.struct.EventLanding.prototype.pic = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.events.struct.EventLanding.prototype.picMobile = null;
/** @type {DR.roadgames.struct.Video|null} */
DR.events.struct.EventLanding.prototype.video = null;
/** @type {DR.roadgames.struct.Video|null} */
DR.events.struct.EventLanding.prototype.videoMobile = null;

/** @extends {DR._Base} */
DR.events.struct.Settings = function(par){
	/** @private */
	this._t = 1004;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.awardVideoUrl)) this.awardVideoUrl = String(par.awardVideoUrl||'');
	if(DR._Base.is(par.canAddContent)) this.canAddContent = Boolean(par.canAddContent);
	if(DR._Base.is(par.canEnd)) this.canEnd = Boolean(par.canEnd);
	if(DR._Base.is(par.canGiveUp)) this.canGiveUp = Boolean(par.canGiveUp);
	if(DR._Base.is(par.canJoinAsGuest)) this.canJoinAsGuest = Boolean(par.canJoinAsGuest);
	if(DR._Base.is(par.canNavigate)) this.canNavigate = Boolean(par.canNavigate);
	if(DR._Base.is(par.canPause)) this.canPause = Boolean(par.canPause);
	if(DR._Base.is(par.canPauseEnd)) this.canPauseEnd = Boolean(par.canPauseEnd);
	if(DR._Base.is(par.canReplay)) this.canReplay = Boolean(par.canReplay);
	if(DR._Base.is(par.canToggleTracking)) this.canToggleTracking = Boolean(par.canToggleTracking);
	if(DR._Base.is(par.defaultDonationAmount)) this.defaultDonationAmount = (parseInt(par.defaultDonationAmount)||0);
	if(DR._Base.is(par.donationsMessage)) this.donationsMessage = String(par.donationsMessage||'');
	if(DR._Base.is(par.finishLocationVisible)) this.finishLocationVisible = Boolean(par.finishLocationVisible);
	if(DR._Base.is(par.finishPoints)) this.finishPoints = (parseInt(par.finishPoints)||0);
	if(DR._Base.is(par.firstcomerPoints)) this.firstcomerPoints = (parseInt(par.firstcomerPoints)||0);
	if(DR._Base.is(par.gameTime)) this.gameTime = (parseInt(par.gameTime)||0);
	if(DR._Base.is(par.gameType)) this.gameType = String(par.gameType||'');
	if(DR._Base.is(par.hasBrainTeaser)) this.hasBrainTeaser = Boolean(par.hasBrainTeaser);
	if(DR._Base.is(par.hasCircleK)) this.hasCircleK = Boolean(par.hasCircleK);
	if(DR._Base.is(par.hasCoder)) this.hasCoder = Boolean(par.hasCoder);
	if(DR._Base.is(par.hasCrazyWolves)) this.hasCrazyWolves = Boolean(par.hasCrazyWolves);
	if(DR._Base.is(par.hasCustomStickers)) this.hasCustomStickers = Boolean(par.hasCustomStickers);
	if(DR._Base.is(par.hasDetective)) this.hasDetective = Boolean(par.hasDetective);
	if(DR._Base.is(par.hasDonations)) this.hasDonations = Boolean(par.hasDonations);
	if(DR._Base.is(par.hasFinishLocation)) this.hasFinishLocation = Boolean(par.hasFinishLocation);
	if(DR._Base.is(par.hasFinishPoints)) this.hasFinishPoints = Boolean(par.hasFinishPoints);
	if(DR._Base.is(par.hasFirstcomer)) this.hasFirstcomer = Boolean(par.hasFirstcomer);
	if(DR._Base.is(par.hasGoldDigger)) this.hasGoldDigger = Boolean(par.hasGoldDigger);
	if(DR._Base.is(par.hasHelpOnRoad)) this.hasHelpOnRoad = Boolean(par.hasHelpOnRoad);
	if(DR._Base.is(par.hasHints)) this.hasHints = Boolean(par.hasHints);
	if(DR._Base.is(par.hasHotCold)) this.hasHotCold = Boolean(par.hasHotCold);
	if(DR._Base.is(par.hasLivestream)) this.hasLivestream = Boolean(par.hasLivestream);
	if(DR._Base.is(par.hasOvertimeTop)) this.hasOvertimeTop = Boolean(par.hasOvertimeTop);
	if(DR._Base.is(par.hasPacman)) this.hasPacman = Boolean(par.hasPacman);
	if(DR._Base.is(par.hasPeak)) this.hasPeak = Boolean(par.hasPeak);
	if(DR._Base.is(par.hasPhotoMatching)) this.hasPhotoMatching = Boolean(par.hasPhotoMatching);
	if(DR._Base.is(par.hasPrizes)) this.hasPrizes = Boolean(par.hasPrizes);
	if(DR._Base.is(par.hasQuestions)) this.hasQuestions = Boolean(par.hasQuestions);
	if(DR._Base.is(par.hasRadio)) this.hasRadio = Boolean(par.hasRadio);
	if(DR._Base.is(par.hasSponsors)) this.hasSponsors = Boolean(par.hasSponsors);
	if(DR._Base.is(par.hasStartLocation)) this.hasStartLocation = Boolean(par.hasStartLocation);
	if(DR._Base.is(par.hasStickers)) this.hasStickers = Boolean(par.hasStickers);
	if(DR._Base.is(par.hasTimeExtension)) this.hasTimeExtension = Boolean(par.hasTimeExtension);
	if(DR._Base.is(par.hasTooltips)) this.hasTooltips = Boolean(par.hasTooltips);
	if(DR._Base.is(par.hasTracking)) this.hasTracking = Boolean(par.hasTracking);
	if(DR._Base.is(par.hasTreasure)) this.hasTreasure = Boolean(par.hasTreasure);
	if(DR._Base.is(par.hasUnknownDate)) this.hasUnknownDate = Boolean(par.hasUnknownDate);
	if(DR._Base.is(par.hideTreasureList)) this.hideTreasureList = Boolean(par.hideTreasureList);
	if(DR._Base.is(par.isDemo)) this.isDemo = Boolean(par.isDemo);
	if(DR._Base.is(par.isFreeGame)) this.isFreeGame = Boolean(par.isFreeGame);
	if(DR._Base.is(par.isRace)) this.isRace = Boolean(par.isRace);
	if(DR._Base.is(par.isSoloGame)) this.isSoloGame = Boolean(par.isSoloGame);
	if(DR._Base.is(par.locationType)) this.locationType = String(par.locationType||'');
	if(DR._Base.is(par.manualStart)) this.manualStart = Boolean(par.manualStart);
	if(DR._Base.is(par.navigateWithStreetView)) this.navigateWithStreetView = Boolean(par.navigateWithStreetView);
	if(DR._Base.is(par.noTimeLimit)) this.noTimeLimit = Boolean(par.noTimeLimit);
	if(DR._Base.is(par.onlyWithCode)) this.onlyWithCode = Boolean(par.onlyWithCode);
	if(DR._Base.is(par.regionCenter)) this.regionCenter = DR._Base.cast(par.regionCenter);
	if(DR._Base.is(par.resultsByTime)) this.resultsByTime = Boolean(par.resultsByTime);
	if(DR._Base.is(par.showCrazyWolvesConsentScreen)) this.showCrazyWolvesConsentScreen = Boolean(par.showCrazyWolvesConsentScreen);
	if(DR._Base.is(par.ticketPerPerson)) this.ticketPerPerson = Boolean(par.ticketPerPerson);
	if(DR._Base.is(par.transportType)) this.transportType = String(par.transportType||'');
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
	if(DR._Base.is(par.useStreetViewSDK)) this.useStreetViewSDK = Boolean(par.useStreetViewSDK);
	if(DR._Base.is(par.visualizationType)) this.visualizationType = (parseInt(par.visualizationType)||0);
};
DR._Base._types[1004] = DR.events.struct.Settings;
DR.events.struct.Settings[__P] = new DR._Base;
DR.events.struct.Settings[__P][__C] = DR.events.struct.Settings;
/** @type {String} */
DR.events.struct.Settings.prototype.awardVideoUrl = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canAddContent = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canEnd = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canGiveUp = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canJoinAsGuest = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canNavigate = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canPause = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canPauseEnd = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canReplay = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.canToggleTracking = null;
/** @type {Number} */
DR.events.struct.Settings.prototype.defaultDonationAmount = null;
/** @type {String} */
DR.events.struct.Settings.prototype.donationsMessage = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.finishLocationVisible = null;
/** @type {Number} */
DR.events.struct.Settings.prototype.finishPoints = null;
/** @type {Number} */
DR.events.struct.Settings.prototype.firstcomerPoints = null;
/** @type {Number} */
DR.events.struct.Settings.prototype.gameTime = null;
/** @type {String} */
DR.events.struct.Settings.prototype.gameType = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasBrainTeaser = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasCircleK = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasCoder = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasCrazyWolves = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasCustomStickers = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasDetective = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasDonations = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasFinishLocation = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasFinishPoints = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasFirstcomer = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasGoldDigger = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasHelpOnRoad = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasHints = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasHotCold = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasLivestream = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasOvertimeTop = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasPacman = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasPeak = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasPhotoMatching = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasPrizes = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasQuestions = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasRadio = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasSponsors = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasStartLocation = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasStickers = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasTimeExtension = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasTooltips = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasTracking = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasTreasure = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hasUnknownDate = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.hideTreasureList = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.isDemo = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.isFreeGame = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.isRace = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.isSoloGame = null;
/** @type {String} */
DR.events.struct.Settings.prototype.locationType = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.manualStart = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.navigateWithStreetView = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.noTimeLimit = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.onlyWithCode = null;
/** @type {DR.roadgames.struct.Coordinates|null} */
DR.events.struct.Settings.prototype.regionCenter = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.resultsByTime = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.showCrazyWolvesConsentScreen = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.ticketPerPerson = null;
/** @type {String} */
DR.events.struct.Settings.prototype.transportType = null;
/** @type {String} */
DR.events.struct.Settings.prototype.type = null;
/** @type {Boolean} */
DR.events.struct.Settings.prototype.useStreetViewSDK = null;
/** @type {Number} */
DR.events.struct.Settings.prototype.visualizationType = null;

/** @extends {DR._Base} */
DR.events.struct.Sponsors = function(par){
	/** @private */
	this._t = 1290;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.main)){
		var tmp = [];
		for( var k in par.main ) tmp.push(DR._Base.cast(par.main [k]));
		this.main = tmp;
	}
	if(DR._Base.is(par.other)){
		var tmp = [];
		for( var k in par.other ) tmp.push(DR._Base.cast(par.other [k]));
		this.other = tmp;
	}
	if(DR._Base.is(par.prizes)){
		var tmp = [];
		for( var k in par.prizes ) tmp.push(DR._Base.cast(par.prizes [k]));
		this.prizes = tmp;
	}
};
DR._Base._types[1290] = DR.events.struct.Sponsors;
DR.events.struct.Sponsors[__P] = new DR._Base;
DR.events.struct.Sponsors[__P][__C] = DR.events.struct.Sponsors;
/** @type {Array.<DR.events.struct.Sponsor>} */
DR.events.struct.Sponsors.prototype.main = null;
/** @type {Array.<DR.events.struct.Sponsor>} */
DR.events.struct.Sponsors.prototype.other = null;
/** @type {Array.<DR.events.struct.Sponsor>} */
DR.events.struct.Sponsors.prototype.prizes = null;

/** @extends {DR._Base} */
DR.events.struct.EventStats = function(par){
	/** @private */
	this._t = 1309;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.distance)) this.distance = (parseInt(par.distance)||0);
	if(DR._Base.is(par.pins)) this.pins = (parseInt(par.pins)||0);
	if(DR._Base.is(par.players)) this.players = (parseInt(par.players)||0);
};
DR._Base._types[1309] = DR.events.struct.EventStats;
DR.events.struct.EventStats[__P] = new DR._Base;
DR.events.struct.EventStats[__P][__C] = DR.events.struct.EventStats;
/** @type {Number} */
DR.events.struct.EventStats.prototype.distance = null;
/** @type {Number} */
DR.events.struct.EventStats.prototype.pins = null;
/** @type {Number} */
DR.events.struct.EventStats.prototype.players = null;

/** @extends {DR._Base} */
DR.events.struct.EventTicket = function(par){
	/** @private */
	this._t = 1069;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.affiliateDiscount)) this.affiliateDiscount = DR._Base.cast(par.affiliateDiscount);
	if(DR._Base.is(par.affiliatePrice)) this.affiliatePrice = (parseInt(par.affiliatePrice)||0);
	if(DR._Base.is(par.affiliatePriceNoVAT)) this.affiliatePriceNoVAT = (parseInt(par.affiliatePriceNoVAT)||0);
	if(DR._Base.is(par.benefits)){
		var tmp = [];
		for( var k in par.benefits ) tmp.push(String(par.benefits [k]||''));
		this.benefits = tmp;
	}
	if(DR._Base.is(par.canPurchase)) this.canPurchase = Boolean(par.canPurchase);
	if(DR._Base.is(par.description)) this.description = String(par.description||'');
	if(DR._Base.is(par.firstAffiliateDiscount)) this.firstAffiliateDiscount = DR._Base.cast(par.firstAffiliateDiscount);
	if(DR._Base.is(par.hasAffiliateDiscount)) this.hasAffiliateDiscount = Boolean(par.hasAffiliateDiscount);
	if(DR._Base.is(par.hasFirstAffiliateDiscount)) this.hasFirstAffiliateDiscount = Boolean(par.hasFirstAffiliateDiscount);
	if(DR._Base.is(par.price)) this.price = (parseInt(par.price)||0);
	if(DR._Base.is(par.priceChange)) this.priceChange = (parseInt(par.priceChange)||0);
	if(DR._Base.is(par.prices)){
		var tmp = [];
		for( var k in par.prices ) tmp.push(DR._Base.cast(par.prices [k]));
		this.prices = tmp;
	}
	if(DR._Base.is(par.priceType)) this.priceType = String(par.priceType||'');
	if(DR._Base.is(par.purchaseLink)) this.purchaseLink = String(par.purchaseLink||'');
	if(DR._Base.is(par.purchaseUrl)) this.purchaseUrl = String(par.purchaseUrl||'');
	if(DR._Base.is(par.vat)) this.vat = (parseInt(par.vat)||0);
};
DR._Base._types[1069] = DR.events.struct.EventTicket;
DR.events.struct.EventTicket[__P] = new DR._Base;
DR.events.struct.EventTicket[__P][__C] = DR.events.struct.EventTicket;
/** @type {DR.events.struct.DiscountData|null} */
DR.events.struct.EventTicket.prototype.affiliateDiscount = null;
/** @type {Number} */
DR.events.struct.EventTicket.prototype.affiliatePrice = null;
/** @type {Number} */
DR.events.struct.EventTicket.prototype.affiliatePriceNoVAT = null;
/** @type {Array.<String>} */
DR.events.struct.EventTicket.prototype.benefits = null;
/** @type {Boolean} */
DR.events.struct.EventTicket.prototype.canPurchase = null;
/** @type {String} */
DR.events.struct.EventTicket.prototype.description = null;
/** @type {DR.events.struct.DiscountData|null} */
DR.events.struct.EventTicket.prototype.firstAffiliateDiscount = null;
/** @type {Boolean} */
DR.events.struct.EventTicket.prototype.hasAffiliateDiscount = null;
/** @type {Boolean} */
DR.events.struct.EventTicket.prototype.hasFirstAffiliateDiscount = null;
/** @type {Number} */
DR.events.struct.EventTicket.prototype.price = null;
/** @type {Number|null} */
DR.events.struct.EventTicket.prototype.priceChange = null;
/** @type {Array.<DR.events.struct.TicketPrice>} */
DR.events.struct.EventTicket.prototype.prices = null;
/** @type {String|null} */
DR.events.struct.EventTicket.prototype.priceType = null;
/** @type {String|null} */
DR.events.struct.EventTicket.prototype.purchaseLink = null;
/** @type {String|null} */
DR.events.struct.EventTicket.prototype.purchaseUrl = null;
/** @type {Number} */
DR.events.struct.EventTicket.prototype.vat = null;

/** @extends {DR._Base} */
DR.events.struct.UserRating = function(par){
	/** @private */
	this._t = 1282;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.rating)) this.rating = (parseFloat(par.rating)||0);
	if(DR._Base.is(par.users)) this.users = (parseInt(par.users)||0);
};
DR._Base._types[1282] = DR.events.struct.UserRating;
DR.events.struct.UserRating[__P] = new DR._Base;
DR.events.struct.UserRating[__P][__C] = DR.events.struct.UserRating;
/** @type {Number} */
DR.events.struct.UserRating.prototype.rating = null;
/** @type {Number} */
DR.events.struct.UserRating.prototype.users = null;

/** @extends {DR._Base} */
DR.events.struct.Event = function(par){
	/** @private */
	this._t = 1002;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.animation)) this.animation = String(par.animation||'');
	if(DR._Base.is(par.canShare)) this.canShare = Boolean(par.canShare);
	if(DR._Base.is(par.countries)){
		var tmp = [];
		for( var k in par.countries ) tmp.push(String(par.countries [k]||''));
		this.countries = tmp;
	}
	if(DR._Base.is(par.defaultLanguage)) this.defaultLanguage = String(par.defaultLanguage||'');
	if(DR._Base.is(par.description)) this.description = String(par.description||'');
	if(DR._Base.is(par.endTime)) this.endTime = (parseInt(par.endTime)||0);
	if(DR._Base.is(par.finishTime)) this.finishTime = (parseInt(par.finishTime)||0);
	if(DR._Base.is(par.gallery)){
		var tmp = [];
		for( var k in par.gallery ) tmp.push(DR._Base.cast(par.gallery [k]));
		this.gallery = tmp;
	}
	if(DR._Base.is(par.hasEnded)) this.hasEnded = Boolean(par.hasEnded);
	if(DR._Base.is(par.hasImage)) this.hasImage = Boolean(par.hasImage);
	if(DR._Base.is(par.hasLandingImage)) this.hasLandingImage = Boolean(par.hasLandingImage);
	if(DR._Base.is(par.hasLandingPage)) this.hasLandingPage = Boolean(par.hasLandingPage);
	if(DR._Base.is(par.hasPartnerImage)) this.hasPartnerImage = Boolean(par.hasPartnerImage);
	if(DR._Base.is(par.hasRated)) this.hasRated = Boolean(par.hasRated);
	if(DR._Base.is(par.hasSubEvent)) this.hasSubEvent = Boolean(par.hasSubEvent);
	if(DR._Base.is(par.hasTeam)) this.hasTeam = Boolean(par.hasTeam);
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.isAdmin)) this.isAdmin = Boolean(par.isAdmin);
	if(DR._Base.is(par.isDemo)) this.isDemo = Boolean(par.isDemo);
	if(DR._Base.is(par.isFavorite)) this.isFavorite = Boolean(par.isFavorite);
	if(DR._Base.is(par.isNewGame)) this.isNewGame = Boolean(par.isNewGame);
	if(DR._Base.is(par.isSubEvent)) this.isSubEvent = Boolean(par.isSubEvent);
	if(DR._Base.is(par.landing)) this.landing = DR._Base.cast(par.landing);
	if(DR._Base.is(par.landingImage)) this.landingImage = DR._Base.cast(par.landingImage);
	if(DR._Base.is(par.languages)){
		var tmp = [];
		for( var k in par.languages ) tmp.push(String(par.languages [k]||''));
		this.languages = tmp;
	}
	if(DR._Base.is(par.languagesWeb)){
		var tmp = [];
		for( var k in par.languagesWeb ) tmp.push(String(par.languagesWeb [k]||''));
		this.languagesWeb = tmp;
	}
	if(DR._Base.is(par.mainEventId)) this.mainEventId = (parseInt(par.mainEventId)||0);
	if(DR._Base.is(par.maxPlayers)) this.maxPlayers = (parseInt(par.maxPlayers)||0);
	if(DR._Base.is(par.minPlayers)) this.minPlayers = (parseInt(par.minPlayers)||0);
	if(DR._Base.is(par.partnerImage)) this.partnerImage = DR._Base.cast(par.partnerImage);
	if(DR._Base.is(par.recommendedBy)){
		var tmp = [];
		for( var k in par.recommendedBy ) tmp.push(DR._Base.cast(par.recommendedBy [k]));
		this.recommendedBy = tmp;
	}
	if(DR._Base.is(par.region)) this.region = String(par.region||'');
	if(DR._Base.is(par.regionCenterImage)) this.regionCenterImage = DR._Base.cast(par.regionCenterImage);
	if(DR._Base.is(par.regionImage)) this.regionImage = DR._Base.cast(par.regionImage);
	if(DR._Base.is(par.registrationDate)) this.registrationDate = (parseInt(par.registrationDate)||0);
	if(DR._Base.is(par.seoTitle)) this.seoTitle = String(par.seoTitle||'');
	if(DR._Base.is(par.settings)) this.settings = DR._Base.cast(par.settings);
	if(DR._Base.is(par.shortUrl)) this.shortUrl = String(par.shortUrl||'');
	if(DR._Base.is(par.showResults)) this.showResults = Boolean(par.showResults);
	if(DR._Base.is(par.sponsors)) this.sponsors = DR._Base.cast(par.sponsors);
	if(DR._Base.is(par.startImage)) this.startImage = DR._Base.cast(par.startImage);
	if(DR._Base.is(par.startTime)) this.startTime = (parseInt(par.startTime)||0);
	if(DR._Base.is(par.startVideo)) this.startVideo = DR._Base.cast(par.startVideo);
	if(DR._Base.is(par.stats)) this.stats = DR._Base.cast(par.stats);
	if(DR._Base.is(par.status)) this.status = String(par.status||'');
	if(DR._Base.is(par.subEventId)) this.subEventId = (parseInt(par.subEventId)||0);
	if(DR._Base.is(par.tags)){
		var tmp = [];
		for( var k in par.tags ) tmp.push(String(par.tags [k]||''));
		this.tags = tmp;
	}
	if(DR._Base.is(par.ticket)) this.ticket = DR._Base.cast(par.ticket);
	if(DR._Base.is(par.title)) this.title = String(par.title||'');
	if(DR._Base.is(par.userRating)) this.userRating = DR._Base.cast(par.userRating);
};
DR._Base._types[1002] = DR.events.struct.Event;
DR.events.struct.Event.STATUS_REGISTRATION = "registration";
DR.events.struct.Event.STATUS_NOT_STARTED = "not_started";
DR.events.struct.Event.STATUS_STARTED = "started";
DR.events.struct.Event.STATUS_ENDED = "ended";
DR.events.struct.Event.STATUS_FINISHED = "finished";
DR.events.struct.Event[__P] = new DR._Base;
DR.events.struct.Event[__P][__C] = DR.events.struct.Event;
/** @type {String|null} */
DR.events.struct.Event.prototype.animation = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.canShare = null;
/** @type {Array.<String>} */
DR.events.struct.Event.prototype.countries = null;
/** @type {String} */
DR.events.struct.Event.prototype.defaultLanguage = null;
/** @type {String} */
DR.events.struct.Event.prototype.description = null;
/** @type {Number} */
DR.events.struct.Event.prototype.endTime = null;
/** @type {Number} */
DR.events.struct.Event.prototype.finishTime = null;
/** @type {Array.<DR.roadgames.struct.Pic>} */
DR.events.struct.Event.prototype.gallery = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.hasEnded = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.hasImage = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.hasLandingImage = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.hasLandingPage = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.hasPartnerImage = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.hasRated = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.hasSubEvent = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.hasTeam = null;
/** @type {Number} */
DR.events.struct.Event.prototype.id = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.events.struct.Event.prototype.image = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.isAdmin = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.isDemo = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.isFavorite = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.isNewGame = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.isSubEvent = null;
/** @type {DR.events.struct.EventLanding} */
DR.events.struct.Event.prototype.landing = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.events.struct.Event.prototype.landingImage = null;
/** @type {Array.<String>} */
DR.events.struct.Event.prototype.languages = null;
/** @type {Array.<String>} */
DR.events.struct.Event.prototype.languagesWeb = null;
/** @type {Number|null} */
DR.events.struct.Event.prototype.mainEventId = null;
/** @type {Number} */
DR.events.struct.Event.prototype.maxPlayers = null;
/** @type {Number} */
DR.events.struct.Event.prototype.minPlayers = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.events.struct.Event.prototype.partnerImage = null;
/** @type {Array.<DR.teams.struct.Team>} */
DR.events.struct.Event.prototype.recommendedBy = null;
/** @type {String} */
DR.events.struct.Event.prototype.region = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.events.struct.Event.prototype.regionCenterImage = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.events.struct.Event.prototype.regionImage = null;
/** @type {Number} */
DR.events.struct.Event.prototype.registrationDate = null;
/** @type {String} */
DR.events.struct.Event.prototype.seoTitle = null;
/** @type {DR.events.struct.Settings} */
DR.events.struct.Event.prototype.settings = null;
/** @type {String} */
DR.events.struct.Event.prototype.shortUrl = null;
/** @type {Boolean} */
DR.events.struct.Event.prototype.showResults = null;
/** @type {DR.events.struct.Sponsors} */
DR.events.struct.Event.prototype.sponsors = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.events.struct.Event.prototype.startImage = null;
/** @type {Number} */
DR.events.struct.Event.prototype.startTime = null;
/** @type {DR.roadgames.struct.Video|null} */
DR.events.struct.Event.prototype.startVideo = null;
/** @type {DR.events.struct.EventStats} */
DR.events.struct.Event.prototype.stats = null;
/** @type {String} */
DR.events.struct.Event.prototype.status = null;
/** @type {Number|null} */
DR.events.struct.Event.prototype.subEventId = null;
/** @type {Array.<String>} */
DR.events.struct.Event.prototype.tags = null;
/** @type {DR.events.struct.EventTicket} */
DR.events.struct.Event.prototype.ticket = null;
/** @type {String} */
DR.events.struct.Event.prototype.title = null;
/** @type {DR.events.struct.UserRating} */
DR.events.struct.Event.prototype.userRating = null;

/** @extends {DR._Select} */
DR.events.select.Event = function(){
	this._fields = {};
};
DR.events.select.Event[__CL] = "Events__Event";
DR.events.select.Event[__P] = new DR._Select;
DR.events.select.Event[__P][__C] = DR.events.select.Event;
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.animation = function(v){ this._fields.animation = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.canShare = function(v){ this._fields.canShare = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.countries = function(v){ this._fields.countries = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.defaultLanguage = function(v){ this._fields.defaultLanguage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.description = function(v){ this._fields.description = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.endTime = function(v){ this._fields.endTime = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.finishTime = function(v){ this._fields.finishTime = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.gallery = function(v){ this._fields.gallery = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.hasEnded = function(v){ this._fields.hasEnded = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.hasImage = function(v){ this._fields.hasImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.hasLandingImage = function(v){ this._fields.hasLandingImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.hasLandingPage = function(v){ this._fields.hasLandingPage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.hasPartnerImage = function(v){ this._fields.hasPartnerImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.hasRated = function(v){ this._fields.hasRated = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.hasSubEvent = function(v){ this._fields.hasSubEvent = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.hasTeam = function(v){ this._fields.hasTeam = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.id = function(v){ this._fields.id = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.image = function(v){ this._fields.image = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.isAdmin = function(v){ this._fields.isAdmin = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.isDemo = function(v){ this._fields.isDemo = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.isFavorite = function(v){ this._fields.isFavorite = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.isNewGame = function(v){ this._fields.isNewGame = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.isSubEvent = function(v){ this._fields.isSubEvent = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.landing = function(v){ this._fields.landing = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.landingImage = function(v){ this._fields.landingImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.languages = function(v){ this._fields.languages = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.languagesWeb = function(v){ this._fields.languagesWeb = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.mainEventId = function(v){ this._fields.mainEventId = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.maxPlayers = function(v){ this._fields.maxPlayers = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.minPlayers = function(v){ this._fields.minPlayers = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.partnerImage = function(v){ this._fields.partnerImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.recommendedBy = function(v){ this._fields.recommendedBy = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.region = function(v){ this._fields.region = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.regionCenterImage = function(v){ this._fields.regionCenterImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.regionImage = function(v){ this._fields.regionImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.registrationDate = function(v){ this._fields.registrationDate = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.seoTitle = function(v){ this._fields.seoTitle = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.settings = function(v){ this._fields.settings = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.shortUrl = function(v){ this._fields.shortUrl = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.showResults = function(v){ this._fields.showResults = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.sponsors = function(v){ this._fields.sponsors = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.startImage = function(v){ this._fields.startImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.startTime = function(v){ this._fields.startTime = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.startVideo = function(v){ this._fields.startVideo = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.stats = function(v){ this._fields.stats = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.status = function(v){ this._fields.status = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.subEventId = function(v){ this._fields.subEventId = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.tags = function(v){ this._fields.tags = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.ticket = function(v){ this._fields.ticket = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.title = function(v){ this._fields.title = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.Event} */
DR.events.select.Event.prototype.userRating = function(v){ this._fields.userRating = !DR._Base.is(v) || !!v; return this; };

/** @extends {DR._Base} */
DR.events.struct.EventsListTeam = function(par){
	/** @private */
	this._t = 1061;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.canInvite)) this.canInvite = Boolean(par.canInvite);
	if(DR._Base.is(par.inviteLink)) this.inviteLink = String(par.inviteLink||'');
	if(DR._Base.is(par.isPaid)) this.isPaid = Boolean(par.isPaid);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
	if(DR._Base.is(par.users)){
		var tmp = [];
		for( var k in par.users ) tmp.push(DR._Base.cast(par.users [k]));
		this.users = tmp;
	}
};
DR._Base._types[1061] = DR.events.struct.EventsListTeam;
DR.events.struct.EventsListTeam[__P] = new DR._Base;
DR.events.struct.EventsListTeam[__P][__C] = DR.events.struct.EventsListTeam;
/** @type {Boolean} */
DR.events.struct.EventsListTeam.prototype.canInvite = null;
/** @type {String} */
DR.events.struct.EventsListTeam.prototype.inviteLink = null;
/** @type {Boolean} */
DR.events.struct.EventsListTeam.prototype.isPaid = null;
/** @type {DR.teams.struct.Team} */
DR.events.struct.EventsListTeam.prototype.team = null;
/** @type {Array.<DR.users.struct.User>} */
DR.events.struct.EventsListTeam.prototype.users = null;

/** @extends {DR._Base} */
DR.events.struct.EventsListItem = function(par){
	/** @private */
	this._t = 1062;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1062] = DR.events.struct.EventsListItem;
DR.events.struct.EventsListItem[__P] = new DR._Base;
DR.events.struct.EventsListItem[__P][__C] = DR.events.struct.EventsListItem;
/** @type {DR.events.struct.Event} */
DR.events.struct.EventsListItem.prototype.event = null;
/** @type {DR.events.struct.EventsListTeam|null} */
DR.events.struct.EventsListItem.prototype.team = null;

/** @extends {DR._Base} */
DR.events.struct.Rule = function(par){
	/** @private */
	this._t = 1095;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.data)) this.data = String(par.data||'');
	if(DR._Base.is(par.images)){
		var tmp = {};
		for( var k in par.images ) tmp[k] = DR._Base.cast(par.images [k]);
		this.images = tmp;
	}
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
};
DR._Base._types[1095] = DR.events.struct.Rule;
DR.events.struct.Rule.TYPE_RULES = "rules";
DR.events.struct.Rule.TYPE_PRIVACY_POLICY = "privacy_policy";
DR.events.struct.Rule.TYPE_HOW_TO_PLAY = "how_to_play";
DR.events.struct.Rule.TYPE_RADIO = "radio";
DR.events.struct.Rule.TYPE_START = "start";
DR.events.struct.Rule.TYPE_FINISH = "finish";
DR.events.struct.Rule.TYPE_TRACKER = "tracker";
DR.events.struct.Rule.TYPE_PRIZES = "prizes";
DR.events.struct.Rule.TYPE_PHOTO = "photo";
DR.events.struct.Rule.TYPE_QUESTION = "question";
DR.events.struct.Rule.TYPE_PACMAN = "pacman";
DR.events.struct.Rule.TYPE_BRAINTEASER = "brainteaser";
DR.events.struct.Rule.TYPE_CRAZYWOLF = "crazywolf";
DR.events.struct.Rule.TYPE_HOTCOLD = "hotcold";
DR.events.struct.Rule.TYPE_CODER = "coder";
DR.events.struct.Rule.TYPE_DETECTIVE = "detective";
DR.events.struct.Rule.TYPE_HELP_ON_ROAD = "help_on_road";
DR.events.struct.Rule.TYPE_TREASURE = "treasure";
DR.events.struct.Rule.TYPE_CODESHARE = "codeshare";
DR.events.struct.Rule.TYPE_GOLDDIGGER = "golddigger";
DR.events.struct.Rule[__P] = new DR._Base;
DR.events.struct.Rule[__P][__C] = DR.events.struct.Rule;
/** @type {String} */
DR.events.struct.Rule.prototype.data = null;
/** @type {Object.<Number,DR.roadgames.struct.Image>} */
DR.events.struct.Rule.prototype.images = null;
/** @type {String} */
DR.events.struct.Rule.prototype.type = null;

/** @extends {DR._Base} */
DR.events.struct.PartnerLocation = function(par){
	/** @private */
	this._t = 1107;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.coordinates)) this.coordinates = DR._Base.cast(par.coordinates);
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.partner)) this.partner = String(par.partner||'');
};
DR._Base._types[1107] = DR.events.struct.PartnerLocation;
DR.events.struct.PartnerLocation[__P] = new DR._Base;
DR.events.struct.PartnerLocation[__P][__C] = DR.events.struct.PartnerLocation;
/** @type {DR.roadgames.struct.Coordinates} */
DR.events.struct.PartnerLocation.prototype.coordinates = null;
/** @type {Number} */
DR.events.struct.PartnerLocation.prototype.id = null;
/** @type {String} */
DR.events.struct.PartnerLocation.prototype.partner = null;

/** @extends {DR._Base} */
DR.events.struct.PinCount = function(par){
	/** @private */
	this._t = 1124;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.available)) this.available = (parseInt(par.available)||0);
	if(DR._Base.is(par.eventId)) this.eventId = (parseInt(par.eventId)||0);
	if(DR._Base.is(par.used)) this.used = (parseInt(par.used)||0);
};
DR._Base._types[1124] = DR.events.struct.PinCount;
DR.events.struct.PinCount[__P] = new DR._Base;
DR.events.struct.PinCount[__P][__C] = DR.events.struct.PinCount;
/** @type {Number} */
DR.events.struct.PinCount.prototype.available = null;
/** @type {Number} */
DR.events.struct.PinCount.prototype.eventId = null;
/** @type {Number} */
DR.events.struct.PinCount.prototype.used = null;

/** @extends {DR._Base} */
DR.events.struct.FilterTag = function(par){
	/** @private */
	this._t = 1315;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.eventUrl)) this.eventUrl = String(par.eventUrl||'');
	if(DR._Base.is(par.tag)) this.tag = String(par.tag||'');
};
DR._Base._types[1315] = DR.events.struct.FilterTag;
DR.events.struct.FilterTag[__P] = new DR._Base;
DR.events.struct.FilterTag[__P][__C] = DR.events.struct.FilterTag;
/** @type {String|null} */
DR.events.struct.FilterTag.prototype.eventUrl = null;
/** @type {String} */
DR.events.struct.FilterTag.prototype.tag = null;

/** @extends {DR._Base} */
DR.events.struct.Tooltip = function(par){
	/** @private */
	this._t = 1227;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.description)) this.description = String(par.description||'');
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.title)) this.title = String(par.title||'');
};
DR._Base._types[1227] = DR.events.struct.Tooltip;
DR.events.struct.Tooltip[__P] = new DR._Base;
DR.events.struct.Tooltip[__P][__C] = DR.events.struct.Tooltip;
/** @type {String} */
DR.events.struct.Tooltip.prototype.description = null;
/** @type {DR.roadgames.struct.Pic|null} */
DR.events.struct.Tooltip.prototype.image = null;
/** @type {String} */
DR.events.struct.Tooltip.prototype.title = null;

/** @extends {DR._Base} */
DR.events.struct.MapMarker = function(par){
	/** @private */
	this._t = 1361;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.location)) this.location = DR._Base.cast(par.location);
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
};
DR._Base._types[1361] = DR.events.struct.MapMarker;
DR.events.struct.MapMarker.TYPE_CAR = "car";
DR.events.struct.MapMarker.TYPE_FOOT = "foot";
DR.events.struct.MapMarker.TYPE_BICYCLE = "bicycle";
DR.events.struct.MapMarker[__P] = new DR._Base;
DR.events.struct.MapMarker[__P][__C] = DR.events.struct.MapMarker;
/** @type {Number} */
DR.events.struct.MapMarker.prototype.id = null;
/** @type {DR.roadgames.struct.Coordinates} */
DR.events.struct.MapMarker.prototype.location = null;
/** @type {String} */
DR.events.struct.MapMarker.prototype.type = null;

/** @extends {DR._Base} */
DR.events.struct.EndGameRe = function(par){
	/** @private */
	this._t = 1225;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1225] = DR.events.struct.EndGameRe;
DR.events.struct.EndGameRe[__P] = new DR._Base;
DR.events.struct.EndGameRe[__P][__C] = DR.events.struct.EndGameRe;
/** @type {DR.events.struct.Event} */
DR.events.struct.EndGameRe.prototype.event = null;
/** @type {DR.teams.struct.Team} */
DR.events.struct.EndGameRe.prototype.team = null;

/** @extends {DR._Base} */
DR.events.struct.EnrollRe = function(par){
	/** @private */
	this._t = 1208;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1208] = DR.events.struct.EnrollRe;
DR.events.struct.EnrollRe[__P] = new DR._Base;
DR.events.struct.EnrollRe[__P][__C] = DR.events.struct.EnrollRe;
/** @type {DR.events.struct.Event} */
DR.events.struct.EnrollRe.prototype.event = null;
/** @type {DR.teams.struct.Team} */
DR.events.struct.EnrollRe.prototype.team = null;

/** @extends {DR._Base} */
DR.events.struct.EnrollDemoRe = function(par){
	/** @private */
	this._t = 1239;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.needAuth)) this.needAuth = Boolean(par.needAuth);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
	if(DR._Base.is(par.user)) this.user = DR._Base.cast(par.user);
};
DR._Base._types[1239] = DR.events.struct.EnrollDemoRe;
DR.events.struct.EnrollDemoRe[__P] = new DR._Base;
DR.events.struct.EnrollDemoRe[__P][__C] = DR.events.struct.EnrollDemoRe;
/** @type {Boolean} */
DR.events.struct.EnrollDemoRe.prototype.needAuth = null;
/** @type {DR.teams.struct.Team|null} */
DR.events.struct.EnrollDemoRe.prototype.team = null;
/** @type {DR.users.struct.AuthRe|null} */
DR.events.struct.EnrollDemoRe.prototype.user = null;

/** @extends {DR._Base} */
DR.events.struct.EventRegion = function(par){
	/** @private */
	this._t = 1209;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)){
		var tmp = [];
		for( var k in par.points ) tmp.push(DR._Base.cast(par.points [k]));
		this.points = tmp;
	}
};
DR._Base._types[1209] = DR.events.struct.EventRegion;
DR.events.struct.EventRegion[__P] = new DR._Base;
DR.events.struct.EventRegion[__P][__C] = DR.events.struct.EventRegion;
/** @type {Array.<DR.roadgames.struct.Coordinates>} */
DR.events.struct.EventRegion.prototype.points = null;

/** @extends {DR._Base} */
DR.events.struct.EventsList = function(par){
	/** @private */
	this._t = 1063;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.countdownText)) this.countdownText = String(par.countdownText||'');
	if(DR._Base.is(par.countdownTime)) this.countdownTime = (parseInt(par.countdownTime)||0);
	if(DR._Base.is(par.defaultCountry)) this.defaultCountry = String(par.defaultCountry||'');
	if(DR._Base.is(par.events)){
		var tmp = [];
		for( var k in par.events ) tmp.push(DR._Base.cast(par.events [k]));
		this.events = tmp;
	}
	if(DR._Base.is(par.featuredEvent)) this.featuredEvent = DR._Base.cast(par.featuredEvent);
};
DR._Base._types[1063] = DR.events.struct.EventsList;
DR.events.struct.EventsList[__P] = new DR._Base;
DR.events.struct.EventsList[__P][__C] = DR.events.struct.EventsList;
/** @type {String|null} */
DR.events.struct.EventsList.prototype.countdownText = null;
/** @type {Number|null} */
DR.events.struct.EventsList.prototype.countdownTime = null;
/** @type {String|null} */
DR.events.struct.EventsList.prototype.defaultCountry = null;
/** @type {Array.<DR.events.struct.EventsListItem>} */
DR.events.struct.EventsList.prototype.events = null;
/** @type {DR.events.struct.EventsListItem|null} */
DR.events.struct.EventsList.prototype.featuredEvent = null;

/** @extends {DR._Base} */
DR.events.struct.GetFilterRe = function(par){
	/** @private */
	this._t = 1305;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.countries)){
		var tmp = [];
		for( var k in par.countries ) tmp.push(String(par.countries [k]||''));
		this.countries = tmp;
	}
	if(DR._Base.is(par.countryBounds)){
		var tmp = {};
		for( var k in par.countryBounds ) tmp[k] = DR._Base.cast(par.countryBounds [k]);
		this.countryBounds = tmp;
	}
};
DR._Base._types[1305] = DR.events.struct.GetFilterRe;
DR.events.struct.GetFilterRe[__P] = new DR._Base;
DR.events.struct.GetFilterRe[__P][__C] = DR.events.struct.GetFilterRe;
/** @type {Array.<String>} */
DR.events.struct.GetFilterRe.prototype.countries = null;
/** @type {Object.<String,DR.roadgames.struct.LatLngBounds>} */
DR.events.struct.GetFilterRe.prototype.countryBounds = null;

/** @extends {DR._Base} */
DR.events.struct.FinishLocation = function(par){
	/** @private */
	this._t = 1106;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.hasArrived)) this.hasArrived = Boolean(par.hasArrived);
	if(DR._Base.is(par.location)) this.location = DR._Base.cast(par.location);
};
DR._Base._types[1106] = DR.events.struct.FinishLocation;
DR.events.struct.FinishLocation[__P] = new DR._Base;
DR.events.struct.FinishLocation[__P][__C] = DR.events.struct.FinishLocation;
/** @type {Boolean} */
DR.events.struct.FinishLocation.prototype.hasArrived = null;
/** @type {DR.roadgames.struct.Coordinates} */
DR.events.struct.FinishLocation.prototype.location = null;

/** @extends {DR._Base} */
DR.events.struct.Rules = function(par){
	/** @private */
	this._t = 1096;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.rules)){
		var tmp = {};
		for( var k in par.rules ) tmp[k] = DR._Base.cast(par.rules [k]);
		this.rules = tmp;
	}
};
DR._Base._types[1096] = DR.events.struct.Rules;
DR.events.struct.Rules[__P] = new DR._Base;
DR.events.struct.Rules[__P][__C] = DR.events.struct.Rules;
/** @type {Object.<String,DR.events.struct.Rule>} */
DR.events.struct.Rules.prototype.rules = null;

/** @extends {DR._Base} */
DR.events.struct.Livestream = function(par){
	/** @private */
	this._t = 1127;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.liveAt)) this.liveAt = (parseInt(par.liveAt)||0);
	if(DR._Base.is(par.youtubeId)) this.youtubeId = String(par.youtubeId||'');
};
DR._Base._types[1127] = DR.events.struct.Livestream;
DR.events.struct.Livestream[__P] = new DR._Base;
DR.events.struct.Livestream[__P][__C] = DR.events.struct.Livestream;
/** @type {Number} */
DR.events.struct.Livestream.prototype.liveAt = null;
/** @type {String} */
DR.events.struct.Livestream.prototype.youtubeId = null;

/** @extends {DR._Base} */
DR.events.struct.PartnerLocations = function(par){
	/** @private */
	this._t = 1108;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.locations)){
		var tmp = [];
		for( var k in par.locations ) tmp.push(DR._Base.cast(par.locations [k]));
		this.locations = tmp;
	}
};
DR._Base._types[1108] = DR.events.struct.PartnerLocations;
DR.events.struct.PartnerLocations[__P] = new DR._Base;
DR.events.struct.PartnerLocations[__P][__C] = DR.events.struct.PartnerLocations;
/** @type {Array.<DR.events.struct.PartnerLocation>} */
DR.events.struct.PartnerLocations.prototype.locations = null;

/** @extends {DR._Base} */
DR.events.struct.GetPinCountsRe = function(par){
	/** @private */
	this._t = 1125;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.items)){
		var tmp = [];
		for( var k in par.items ) tmp.push(DR._Base.cast(par.items [k]));
		this.items = tmp;
	}
};
DR._Base._types[1125] = DR.events.struct.GetPinCountsRe;
DR.events.struct.GetPinCountsRe[__P] = new DR._Base;
DR.events.struct.GetPinCountsRe[__P][__C] = DR.events.struct.GetPinCountsRe;
/** @type {Array.<DR.events.struct.PinCount>} */
DR.events.struct.GetPinCountsRe.prototype.items = null;

/** @extends {DR._Base} */
DR.events.struct.GetSearchTagsRe = function(par){
	/** @private */
	this._t = 1365;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.tags)){
		var tmp = [];
		for( var k in par.tags ) tmp.push(DR._Base.cast(par.tags [k]));
		this.tags = tmp;
	}
};
DR._Base._types[1365] = DR.events.struct.GetSearchTagsRe;
DR.events.struct.GetSearchTagsRe[__P] = new DR._Base;
DR.events.struct.GetSearchTagsRe[__P][__C] = DR.events.struct.GetSearchTagsRe;
/** @type {Array.<DR.events.struct.FilterTag>} */
DR.events.struct.GetSearchTagsRe.prototype.tags = null;

/** @extends {DR._Base} */
DR.events.struct.Stats = function(par){
	/** @private */
	this._t = 1152;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.brainteaser)) this.brainteaser = (parseInt(par.brainteaser)||0);
	if(DR._Base.is(par.clues)) this.clues = (parseInt(par.clues)||0);
	if(DR._Base.is(par.coder)) this.coder = (parseInt(par.coder)||0);
	if(DR._Base.is(par.crazywolf)) this.crazywolf = (parseInt(par.crazywolf)||0);
	if(DR._Base.is(par.golddigger)) this.golddigger = (parseInt(par.golddigger)||0);
	if(DR._Base.is(par.hotcold)) this.hotcold = (parseInt(par.hotcold)||0);
	if(DR._Base.is(par.imagematch)) this.imagematch = (parseInt(par.imagematch)||0);
	if(DR._Base.is(par.pacman)) this.pacman = (parseInt(par.pacman)||0);
	if(DR._Base.is(par.pacmanDiamonds)) this.pacmanDiamonds = (parseInt(par.pacmanDiamonds)||0);
	if(DR._Base.is(par.participants)) this.participants = (parseInt(par.participants)||0);
	if(DR._Base.is(par.question)) this.question = (parseInt(par.question)||0);
	if(DR._Base.is(par.tasks)) this.tasks = (parseInt(par.tasks)||0);
	if(DR._Base.is(par.teams)) this.teams = (parseInt(par.teams)||0);
	if(DR._Base.is(par.treasure)) this.treasure = (parseInt(par.treasure)||0);
};
DR._Base._types[1152] = DR.events.struct.Stats;
DR.events.struct.Stats[__P] = new DR._Base;
DR.events.struct.Stats[__P][__C] = DR.events.struct.Stats;
/** @type {Number} */
DR.events.struct.Stats.prototype.brainteaser = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.clues = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.coder = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.crazywolf = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.golddigger = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.hotcold = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.imagematch = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.pacman = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.pacmanDiamonds = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.participants = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.question = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.tasks = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.teams = null;
/** @type {Number} */
DR.events.struct.Stats.prototype.treasure = null;

/** @extends {DR._Base} */
DR.events.struct.GetTimeExtensionRe = function(par){
	/** @private */
	this._t = 1237;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.price)) this.price = (parseInt(par.price)||0);
	if(DR._Base.is(par.time)) this.time = (parseInt(par.time)||0);
};
DR._Base._types[1237] = DR.events.struct.GetTimeExtensionRe;
DR.events.struct.GetTimeExtensionRe[__P] = new DR._Base;
DR.events.struct.GetTimeExtensionRe[__P][__C] = DR.events.struct.GetTimeExtensionRe;
/** @type {Number} */
DR.events.struct.GetTimeExtensionRe.prototype.price = null;
/** @type {Number} */
DR.events.struct.GetTimeExtensionRe.prototype.time = null;

/** @extends {DR._Base} */
DR.events.struct.GetTooltipsRe = function(par){
	/** @private */
	this._t = 1228;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.tooltips)){
		var tmp = {};
		for( var k in par.tooltips ) tmp[k] = DR._Base.cast(par.tooltips [k]);
		this.tooltips = tmp;
	}
};
DR._Base._types[1228] = DR.events.struct.GetTooltipsRe;
DR.events.struct.GetTooltipsRe[__P] = new DR._Base;
DR.events.struct.GetTooltipsRe[__P][__C] = DR.events.struct.GetTooltipsRe;
/** @type {Object.<String,DR.events.struct.Tooltip>} */
DR.events.struct.GetTooltipsRe.prototype.tooltips = null;

/** @extends {DR._Base} */
DR.events.struct.PauseGameRe = function(par){
	/** @private */
	this._t = 1242;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1242] = DR.events.struct.PauseGameRe;
DR.events.struct.PauseGameRe[__P] = new DR._Base;
DR.events.struct.PauseGameRe[__P][__C] = DR.events.struct.PauseGameRe;
/** @type {DR.events.struct.Event} */
DR.events.struct.PauseGameRe.prototype.event = null;
/** @type {DR.teams.struct.Team} */
DR.events.struct.PauseGameRe.prototype.team = null;

/** @extends {DR._Base} */
DR.events.struct.ReplayRe = function(par){
	/** @private */
	this._t = 1244;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1244] = DR.events.struct.ReplayRe;
DR.events.struct.ReplayRe[__P] = new DR._Base;
DR.events.struct.ReplayRe[__P][__C] = DR.events.struct.ReplayRe;
/** @type {DR.events.struct.Event} */
DR.events.struct.ReplayRe.prototype.event = null;
/** @type {DR.teams.struct.Team} */
DR.events.struct.ReplayRe.prototype.team = null;

/** @extends {DR._Base} */
DR.events.struct.SearchRe = function(par){
	/** @private */
	this._t = 1303;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.events)){
		var tmp = [];
		for( var k in par.events ) tmp.push(DR._Base.cast(par.events [k]));
		this.events = tmp;
	}
	if(DR._Base.is(par.featuredEvent)) this.featuredEvent = DR._Base.cast(par.featuredEvent);
	if(DR._Base.is(par.recommendedEvents)){
		var tmp = [];
		for( var k in par.recommendedEvents ) tmp.push(DR._Base.cast(par.recommendedEvents [k]));
		this.recommendedEvents = tmp;
	}
};
DR._Base._types[1303] = DR.events.struct.SearchRe;
DR.events.struct.SearchRe[__P] = new DR._Base;
DR.events.struct.SearchRe[__P][__C] = DR.events.struct.SearchRe;
/** @type {Array.<DR.events.struct.Event>} */
DR.events.struct.SearchRe.prototype.events = null;
/** @type {DR.events.struct.Event|null} */
DR.events.struct.SearchRe.prototype.featuredEvent = null;
/** @type {Array.<DR.events.struct.Event>} */
DR.events.struct.SearchRe.prototype.recommendedEvents = null;

/** @extends {DR._Select} */
DR.events.select.SearchRe = function(){
	this._fields = {};
};
DR.events.select.SearchRe[__CL] = "Events__SearchRe";
DR.events.select.SearchRe[__P] = new DR._Select;
DR.events.select.SearchRe[__P][__C] = DR.events.select.SearchRe;
/** @param {boolean} [v]
  * @return {DR.events.select.SearchRe} */
DR.events.select.SearchRe.prototype.events = function(v){ this._fields.events = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.SearchRe} */
DR.events.select.SearchRe.prototype.featuredEvent = function(v){ this._fields.featuredEvent = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.events.select.SearchRe} */
DR.events.select.SearchRe.prototype.recommendedEvents = function(v){ this._fields.recommendedEvents = !DR._Base.is(v) || !!v; return this; };

/** @extends {DR._Base} */
DR.events.struct.SearchMapRe = function(par){
	/** @private */
	this._t = 1362;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.foundOutsideBounds)) this.foundOutsideBounds = Boolean(par.foundOutsideBounds);
	if(DR._Base.is(par.mapMarkers)){
		var tmp = [];
		for( var k in par.mapMarkers ) tmp.push(DR._Base.cast(par.mapMarkers [k]));
		this.mapMarkers = tmp;
	}
};
DR._Base._types[1362] = DR.events.struct.SearchMapRe;
DR.events.struct.SearchMapRe[__P] = new DR._Base;
DR.events.struct.SearchMapRe[__P][__C] = DR.events.struct.SearchMapRe;
/** @type {Boolean} */
DR.events.struct.SearchMapRe.prototype.foundOutsideBounds = null;
/** @type {Array.<DR.events.struct.MapMarker>} */
DR.events.struct.SearchMapRe.prototype.mapMarkers = null;

/** @extends {DR._Base} */
DR.events.struct.StartGameRe = function(par){
	/** @private */
	this._t = 1205;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1205] = DR.events.struct.StartGameRe;
DR.events.struct.StartGameRe[__P] = new DR._Base;
DR.events.struct.StartGameRe[__P][__C] = DR.events.struct.StartGameRe;
/** @type {DR.events.struct.Event} */
DR.events.struct.StartGameRe.prototype.event = null;
/** @type {DR.teams.struct.Team} */
DR.events.struct.StartGameRe.prototype.team = null;

/** @extends {DR._Method} */
DR.events.AddFavorite = function(par){
	this.select = [];
	/** @private */
	this._t = 1284;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1284] = DR.events.AddFavorite;
DR.events.AddFavorite[__CL] = "Events__AddFavorite";
DR.events.AddFavorite[__P] = new DR._Method;
DR.events.AddFavorite[__P][__C] = DR.events.AddFavorite;
/** @type {Number} */
DR.events.AddFavorite.prototype.eventId = null;
/** @type {DR.events.struct.Event} */
DR.events.AddFavorite.prototype.re = null;

/** @extends {DR._Method} */
DR.events.AddUserRating = function(par){
	this.select = [];
	/** @private */
	this._t = 1281;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1281] = DR.events.AddUserRating;
DR.events.AddUserRating[__CL] = "Events__AddUserRating";
DR.events.AddUserRating[__P] = new DR._Method;
DR.events.AddUserRating[__P][__C] = DR.events.AddUserRating;
/** @type {String|null} */
DR.events.AddUserRating.prototype.comment = null;
/** @type {Number} */
DR.events.AddUserRating.prototype.rating = null;
/** @type {Number|null} */
DR.events.AddUserRating.prototype.ratingApp = null;
/** @type {Number|null} */
DR.events.AddUserRating.prototype.ratingCon = null;
/** @type {DR.events.struct.Event} */
DR.events.AddUserRating.prototype.re = null;

/** @extends {DR._Method} */
DR.events.EndGame = function(par){
	this.select = [];
	/** @private */
	this._t = 1226;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1226] = DR.events.EndGame;
DR.events.EndGame[__CL] = "Events__EndGame";
DR.events.EndGame[__P] = new DR._Method;
DR.events.EndGame[__P][__C] = DR.events.EndGame;
/** @type {DR.events.struct.EndGameRe} */
DR.events.EndGame.prototype.re = null;

/** @extends {DR._Method} */
DR.events.Enroll = function(par){
	this.select = [];
	/** @private */
	this._t = 1129;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1129] = DR.events.Enroll;
DR.events.Enroll[__CL] = "Events__Enroll";
DR.events.Enroll[__P] = new DR._Method;
DR.events.Enroll[__P][__C] = DR.events.Enroll;
/** @type {String|null} */
DR.events.Enroll.prototype.teamName = null;
/** @type {DR.events.struct.EnrollRe} */
DR.events.Enroll.prototype.re = null;

/** @extends {DR._Method} */
DR.events.EnrollDemo = function(par){
	this.select = [];
	/** @private */
	this._t = 1240;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1240] = DR.events.EnrollDemo;
DR.events.EnrollDemo[__CL] = "Events__EnrollDemo";
DR.events.EnrollDemo[__P] = new DR._Method;
DR.events.EnrollDemo[__P][__C] = DR.events.EnrollDemo;
/** @type {DR.events.struct.EnrollDemoRe} */
DR.events.EnrollDemo.prototype.re = null;

/** @extends {DR._Method} */
DR.events.Get = function(par){
	this.select = [];
	/** @private */
	this._t = 1154;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1154] = DR.events.Get;
DR.events.Get[__CL] = "Events__Get";
DR.events.Get[__P] = new DR._Method;
DR.events.Get[__P][__C] = DR.events.Get;
/** @type {DR.events.struct.Event} */
DR.events.Get.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetDiscountData = function(par){
	this.select = [];
	/** @private */
	this._t = 1288;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1288] = DR.events.GetDiscountData;
DR.events.GetDiscountData[__CL] = "Events__GetDiscountData";
DR.events.GetDiscountData[__P] = new DR._Method;
DR.events.GetDiscountData[__P][__C] = DR.events.GetDiscountData;
/** @type {String} */
DR.events.GetDiscountData.prototype.code = null;
/** @type {DR.events.struct.DiscountData} */
DR.events.GetDiscountData.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetEvent = function(par){
	this.select = [];
	/** @private */
	this._t = 1003;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1003] = DR.events.GetEvent;
DR.events.GetEvent[__CL] = "Events__GetEvent";
DR.events.GetEvent[__P] = new DR._Method;
DR.events.GetEvent[__P][__C] = DR.events.GetEvent;
/** @type {Number} */
DR.events.GetEvent.prototype.eventId = null;
/** @type {DR.events.struct.Event} */
DR.events.GetEvent.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetEventBySeoTitle = function(par){
	this.select = [];
	/** @private */
	this._t = 1150;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1150] = DR.events.GetEventBySeoTitle;
DR.events.GetEventBySeoTitle[__CL] = "Events__GetEventBySeoTitle";
DR.events.GetEventBySeoTitle[__P] = new DR._Method;
DR.events.GetEventBySeoTitle[__P][__C] = DR.events.GetEventBySeoTitle;
/** @type {String} */
DR.events.GetEventBySeoTitle.prototype.seoTitle = null;
/** @type {DR.events.struct.Event} */
DR.events.GetEventBySeoTitle.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetEventByShortUrl = function(par){
	this.select = [];
	/** @private */
	this._t = 1373;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1373] = DR.events.GetEventByShortUrl;
DR.events.GetEventByShortUrl[__CL] = "Events__GetEventByShortUrl";
DR.events.GetEventByShortUrl[__P] = new DR._Method;
DR.events.GetEventByShortUrl[__P][__C] = DR.events.GetEventByShortUrl;
/** @type {String} */
DR.events.GetEventByShortUrl.prototype.shortUrl = null;
/** @type {DR.events.struct.Event} */
DR.events.GetEventByShortUrl.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetEventRegion = function(par){
	this.select = [];
	/** @private */
	this._t = 1210;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1210] = DR.events.GetEventRegion;
DR.events.GetEventRegion[__CL] = "Events__GetEventRegion";
DR.events.GetEventRegion[__P] = new DR._Method;
DR.events.GetEventRegion[__P][__C] = DR.events.GetEventRegion;
/** @type {DR.events.struct.EventRegion} */
DR.events.GetEventRegion.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetEventsList = function(par){
	this.select = [];
	/** @private */
	this._t = 1064;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1064] = DR.events.GetEventsList;
DR.events.GetEventsList[__CL] = "Events__GetEventsList";
DR.events.GetEventsList.TYPE_MY_PAST = "MY_PAST";
DR.events.GetEventsList.TYPE_MY_ACTIVE = "MY_ACTIVE";
DR.events.GetEventsList.TYPE_PAST = "PAST";
DR.events.GetEventsList.TYPE_ACTIVE = "ACTIVE";
DR.events.GetEventsList.TYPE_ALL = "ALL";
DR.events.GetEventsList.TYPE_HOME = "HOME";
DR.events.GetEventsList.TYPE_ANYTIME = "ANYTIME";
DR.events.GetEventsList.TYPE_ONLINE_WEB = "ONLINE_WEB";
DR.events.GetEventsList.TYPE_FAVORITE = "FAVORITE";
DR.events.GetEventsList.TYPE_ACTIVE_SELF = "ACTIVE_SELF";
DR.events.GetEventsList.TYPE_GIFTCARDS = "GIFTCARDS";
DR.events.GetEventsList[__P] = new DR._Method;
DR.events.GetEventsList[__P][__C] = DR.events.GetEventsList;
/** @type {String|null} */
DR.events.GetEventsList.prototype.type = null;
/** @type {DR.events.struct.EventsList} */
DR.events.GetEventsList.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetFilter = function(par){
	this.select = [];
	/** @private */
	this._t = 1306;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1306] = DR.events.GetFilter;
DR.events.GetFilter[__CL] = "Events__GetFilter";
DR.events.GetFilter[__P] = new DR._Method;
DR.events.GetFilter[__P][__C] = DR.events.GetFilter;
/** @type {Boolean|null} */
DR.events.GetFilter.prototype.isVirtual = null;
/** @type {DR.events.struct.GetFilterRe} */
DR.events.GetFilter.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetFinishLocation = function(par){
	this.select = [];
	/** @private */
	this._t = 1103;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1103] = DR.events.GetFinishLocation;
DR.events.GetFinishLocation[__CL] = "Events__GetFinishLocation";
DR.events.GetFinishLocation[__P] = new DR._Method;
DR.events.GetFinishLocation[__P][__C] = DR.events.GetFinishLocation;
/** @type {DR.events.struct.FinishLocation} */
DR.events.GetFinishLocation.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetGlobalRules = function(par){
	this.select = [];
	/** @private */
	this._t = 1336;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1336] = DR.events.GetGlobalRules;
DR.events.GetGlobalRules[__CL] = "Events__GetGlobalRules";
DR.events.GetGlobalRules[__P] = new DR._Method;
DR.events.GetGlobalRules[__P][__C] = DR.events.GetGlobalRules;
/** @type {DR.events.struct.Rules} */
DR.events.GetGlobalRules.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetLivestream = function(par){
	this.select = [];
	/** @private */
	this._t = 1128;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1128] = DR.events.GetLivestream;
DR.events.GetLivestream[__CL] = "Events__GetLivestream";
DR.events.GetLivestream[__P] = new DR._Method;
DR.events.GetLivestream[__P][__C] = DR.events.GetLivestream;
/** @type {DR.events.struct.Livestream} */
DR.events.GetLivestream.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetPartnerLocations = function(par){
	this.select = [];
	/** @private */
	this._t = 1109;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1109] = DR.events.GetPartnerLocations;
DR.events.GetPartnerLocations[__CL] = "Events__GetPartnerLocations";
DR.events.GetPartnerLocations[__P] = new DR._Method;
DR.events.GetPartnerLocations[__P][__C] = DR.events.GetPartnerLocations;
/** @type {DR.events.struct.PartnerLocations} */
DR.events.GetPartnerLocations.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetPinCounts = function(par){
	this.select = [];
	/** @private */
	this._t = 1126;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1126] = DR.events.GetPinCounts;
DR.events.GetPinCounts[__CL] = "Events__GetPinCounts";
DR.events.GetPinCounts[__P] = new DR._Method;
DR.events.GetPinCounts[__P][__C] = DR.events.GetPinCounts;
/** @type {DR.events.struct.GetPinCountsRe} */
DR.events.GetPinCounts.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetRules = function(par){
	this.select = [];
	/** @private */
	this._t = 1097;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1097] = DR.events.GetRules;
DR.events.GetRules[__CL] = "Events__GetRules";
DR.events.GetRules[__P] = new DR._Method;
DR.events.GetRules[__P][__C] = DR.events.GetRules;
/** @type {DR.events.struct.Rules} */
DR.events.GetRules.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetSearchTags = function(par){
	this.select = [];
	/** @private */
	this._t = 1366;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1366] = DR.events.GetSearchTags;
DR.events.GetSearchTags[__CL] = "Events__GetSearchTags";
DR.events.GetSearchTags[__P] = new DR._Method;
DR.events.GetSearchTags[__P][__C] = DR.events.GetSearchTags;
/** @type {Boolean|null} */
DR.events.GetSearchTags.prototype.isVirtual = null;
/** @type {DR.events.struct.GetSearchTagsRe} */
DR.events.GetSearchTags.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetStats = function(par){
	this.select = [];
	/** @private */
	this._t = 1153;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1153] = DR.events.GetStats;
DR.events.GetStats[__CL] = "Events__GetStats";
DR.events.GetStats[__P] = new DR._Method;
DR.events.GetStats[__P][__C] = DR.events.GetStats;
/** @type {DR.events.struct.Stats} */
DR.events.GetStats.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetSubEvents = function(par){
	this.select = [];
	/** @private */
	this._t = 1121;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1121] = DR.events.GetSubEvents;
DR.events.GetSubEvents[__CL] = "Events__GetSubEvents";
DR.events.GetSubEvents[__P] = new DR._Method;
DR.events.GetSubEvents[__P][__C] = DR.events.GetSubEvents;
/** @type {DR.events.struct.EventsList} */
DR.events.GetSubEvents.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetTimeExtension = function(par){
	this.select = [];
	/** @private */
	this._t = 1238;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1238] = DR.events.GetTimeExtension;
DR.events.GetTimeExtension[__CL] = "Events__GetTimeExtension";
DR.events.GetTimeExtension[__P] = new DR._Method;
DR.events.GetTimeExtension[__P][__C] = DR.events.GetTimeExtension;
/** @type {DR.events.struct.GetTimeExtensionRe} */
DR.events.GetTimeExtension.prototype.re = null;

/** @extends {DR._Method} */
DR.events.GetTooltips = function(par){
	this.select = [];
	/** @private */
	this._t = 1229;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1229] = DR.events.GetTooltips;
DR.events.GetTooltips[__CL] = "Events__GetTooltips";
DR.events.GetTooltips[__P] = new DR._Method;
DR.events.GetTooltips[__P][__C] = DR.events.GetTooltips;
/** @type {DR.events.struct.GetTooltipsRe} */
DR.events.GetTooltips.prototype.re = null;

/** @extends {DR._Method} */
DR.events.PauseGame = function(par){
	this.select = [];
	/** @private */
	this._t = 1243;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1243] = DR.events.PauseGame;
DR.events.PauseGame[__CL] = "Events__PauseGame";
DR.events.PauseGame[__P] = new DR._Method;
DR.events.PauseGame[__P][__C] = DR.events.PauseGame;
/** @type {DR.events.struct.PauseGameRe} */
DR.events.PauseGame.prototype.re = null;

/** @extends {DR._Method} */
DR.events.RefuseTimeExtension = function(par){
	this.select = [];
	/** @private */
	this._t = 1241;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1241] = DR.events.RefuseTimeExtension;
DR.events.RefuseTimeExtension[__CL] = "Events__RefuseTimeExtension";
DR.events.RefuseTimeExtension[__P] = new DR._Method;
DR.events.RefuseTimeExtension[__P][__C] = DR.events.RefuseTimeExtension;
/** @type {DR.roadgames.struct.Status} */
DR.events.RefuseTimeExtension.prototype.re = null;

/** @extends {DR._Method} */
DR.events.RemoveFavorite = function(par){
	this.select = [];
	/** @private */
	this._t = 1285;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1285] = DR.events.RemoveFavorite;
DR.events.RemoveFavorite[__CL] = "Events__RemoveFavorite";
DR.events.RemoveFavorite[__P] = new DR._Method;
DR.events.RemoveFavorite[__P][__C] = DR.events.RemoveFavorite;
/** @type {Number} */
DR.events.RemoveFavorite.prototype.eventId = null;
/** @type {DR.events.struct.Event} */
DR.events.RemoveFavorite.prototype.re = null;

/** @extends {DR._Method} */
DR.events.Replay = function(par){
	this.select = [];
	/** @private */
	this._t = 1245;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1245] = DR.events.Replay;
DR.events.Replay[__CL] = "Events__Replay";
DR.events.Replay[__P] = new DR._Method;
DR.events.Replay[__P][__C] = DR.events.Replay;
/** @type {DR.events.struct.ReplayRe} */
DR.events.Replay.prototype.re = null;

/** @extends {DR._Method} */
DR.events.Search = function(par){
	this.select = [];
	/** @private */
	this._t = 1304;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1304] = DR.events.Search;
DR.events.Search[__CL] = "Events__Search";
DR.events.Search.SORTTYPE_NEWEST = "newest";
DR.events.Search.SORTTYPE_DISTANCE = "distance";
DR.events.Search.SORTTYPE_RATING = "rating";
DR.events.Search.SORTTYPE_POPULARITY = "popularity";
DR.events.Search.TRANSPORTTYPE_CAR = "car";
DR.events.Search.TRANSPORTTYPE_FOOT = "foot";
DR.events.Search.TRANSPORTTYPE_BICYCLE = "bicycle";
DR.events.Search[__P] = new DR._Method;
DR.events.Search[__P][__C] = DR.events.Search;
/** @type {Number} */
DR.events.Search.prototype.count = null;
/** @type {String|null} */
DR.events.Search.prototype.country = null;
/** @type {String|null} */
DR.events.Search.prototype.kw = null;
/** @type {Number} */
DR.events.Search.prototype.pg = null;
/** @type {String} */
DR.events.Search.prototype.sortType = null;
/** @type {String|null} */
DR.events.Search.prototype.tag = null;
/** @type {Array.<String>|null} */
DR.events.Search.prototype.transportType = null;
/** @type {DR.roadgames.struct.Coordinates|null} */
DR.events.Search.prototype.userLocation = null;
/** @type {DR.events.struct.SearchRe} */
DR.events.Search.prototype.re = null;

/** @extends {DR._Method} */
DR.events.SearchMap = function(par){
	this.select = [];
	/** @private */
	this._t = 1363;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1363] = DR.events.SearchMap;
DR.events.SearchMap[__CL] = "Events__SearchMap";
DR.events.SearchMap.TRANSPORTTYPE_CAR = "car";
DR.events.SearchMap.TRANSPORTTYPE_FOOT = "foot";
DR.events.SearchMap.TRANSPORTTYPE_BICYCLE = "bicycle";
DR.events.SearchMap[__P] = new DR._Method;
DR.events.SearchMap[__P][__C] = DR.events.SearchMap;
/** @type {DR.roadgames.struct.Coordinates} */
DR.events.SearchMap.prototype.boundsNorthEast = null;
/** @type {DR.roadgames.struct.Coordinates} */
DR.events.SearchMap.prototype.boundsSouthWest = null;
/** @type {Boolean|null} */
DR.events.SearchMap.prototype.findOutsideBounds = null;
/** @type {String|null} */
DR.events.SearchMap.prototype.kw = null;
/** @type {String|null} */
DR.events.SearchMap.prototype.tag = null;
/** @type {Array.<String>|null} */
DR.events.SearchMap.prototype.transportType = null;
/** @type {DR.events.struct.SearchMapRe} */
DR.events.SearchMap.prototype.re = null;

/** @extends {DR._Method} */
DR.events.StartGame = function(par){
	this.select = [];
	/** @private */
	this._t = 1206;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1206] = DR.events.StartGame;
DR.events.StartGame[__CL] = "Events__StartGame";
DR.events.StartGame[__P] = new DR._Method;
DR.events.StartGame[__P][__C] = DR.events.StartGame;
/** @type {DR.events.struct.StartGameRe} */
DR.events.StartGame.prototype.re = null;

D.loaded();